module.exports = __webpack_public_path__ + "static/media/html5.aa7659e3.svg";